import { colorPalette } from '../../colorPalette';
import { inputBaseClasses } from '@mui/material/InputBase';
const $border = `1px solid ${colorPalette.gray200}`;
const $boxShadow = `0px 0px 0px 4px ${colorPalette.gray100}`;
const borderStyle = {
    borderLeft: $border,
    borderRight: $border,
    borderBottom: $border,
};
const roundedBottomStyle = {
    borderBottomLeftRadius: 3,
    borderBottomRightRadius: 3,
};
export const searchAutocomplete = {
    margin: 0,
    '& .MuiFilledInput-root.MuiInputBase-root': {
        padding: '0 12px !important',
    },
};
export const searchStyleInput = (sxInput, noAutocomplete) => {
    let noBorder;
    if (!noAutocomplete) {
        noBorder = {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        };
    }
    return Object.assign({ backgroundColor: colorPalette.gray100, borderColor: colorPalette.gray300, borderRadius: '4px', [`.${inputBaseClasses.input}`]: {
            padding: '14px 12px 14px 0 !important',
            color: colorPalette.gray700,
            lineHeight: '18px',
        }, '&:hover': {
            border: `1px solid ${colorPalette.gray300}`,
            boxShadow: $boxShadow,
        }, '&:active': {
            color: colorPalette.gray900,
        }, '&:focus, &.Mui-focused': Object.assign({ borderColor: colorPalette.gray900, boxShadow: $boxShadow, color: colorPalette.gray300 }, noBorder) }, sxInput);
};
export const searchStyleTextField = (sx) => {
    return Object.assign({ margin: 0, '& .MuiFilledInput-root.MuiInputBase-root.MuiInputBase-formControl.MuiAutocomplete-inputRoot': {
            padding: '0 14px',
        } }, sx);
};
export const searchStyleAutocompletePopover = {
    margin: '0 -1px',
    padding: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    '& ul': {
        padding: 0,
    },
    '& li': Object.assign(Object.assign(Object.assign({}, borderStyle), roundedBottomStyle), { padding: '12px 16px', color: colorPalette.gray700 }),
};
export const searchStyleAutocompleteOption = Object.assign(Object.assign({}, borderStyle), { '&.MuiAutocomplete-option.Mui-focusVisible': {
        backgroundColor: colorPalette.gray100,
    }, '&.MuiAutocomplete-option': {
        padding: '12px 16px',
        color: colorPalette.gray700,
    }, '&:last-child': Object.assign({}, roundedBottomStyle) });
